import { AvailableQueryParams } from '../../../styledComponents/MaterialTable/materialTable.models';

export const RequiredQueryParams = [
  AvailableQueryParams.Order,
  AvailableQueryParams.OrderBy,
  AvailableQueryParams.PageNumber,
  AvailableQueryParams.PageSize,
];
